export type LogLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'off';

const order: LogLevel[] = ['trace', 'debug', 'info', 'warn', 'error', 'off'];
export const levelEnabled = (current: LogLevel, target: LogLevel) =>
  order.indexOf(target) >= order.indexOf(current);
